import type {
  CommitmentCommandData,
  PretendCommitmentCommandData,
} from '@festina/life-general-types/life'
import type { ExcludeString } from '@festina-life/core'

import { AddBalancePostingsCommand } from '../../actions/addBalancePostings/AddBalancePostingsCommand'
import { ChangeCommitmentCommand } from '../../actions/ChangeCommitmentCommand'
import { CreatePolicyCommand } from '../../actions/CreatePolicyCommand'
import { LifeRollbackCommand } from '../../actions/LifeRollbackCommand'
import { CreateCommitmentCommand } from '../../legalentityactions/CreateCommitmentCommand'
import { CommitmentCommandModalButtonFallback } from '../CommitmentCommandModalButtonFallback'
import {
  type CommitmentCommandDataRecord,
  ensureAllComponentsAreCommitment,
} from '../types'

export const commitmentCommands: CommitmentCommandDataRecord<
  Exclude<
    ExcludeString<CommitmentCommandData['_type']>,
    ExcludeString<PretendCommitmentCommandData['_type']>
  >
> = ensureAllComponentsAreCommitment({
  AddBalancePostingsCommandData: AddBalancePostingsCommand,
  AddManualPaymentCommandData: CommitmentCommandModalButtonFallback,
  AmendCoversSelectionCommandData: CommitmentCommandModalButtonFallback,
  ChangeCoverRestrictionCommandData: CommitmentCommandModalButtonFallback,
  ChangeTaxExemptionCommandData: CommitmentCommandModalButtonFallback, // Lives in DK
  ChangeCommitmentAndStateCommandData: ChangeCommitmentCommand,
  DeathClaimCommandData: CommitmentCommandModalButtonFallback, // Exists in DK and NL
  DeathClaimOrphanCommandData: CommitmentCommandModalButtonFallback, // Exists in the NL layer
  EmploymentCommandData: CommitmentCommandModalButtonFallback, // Exists in DK and NL
  EmploymentCommitmentCommandData: CommitmentCommandModalButtonFallback,
  EmploymentContributionCommandData: CommitmentCommandModalButtonFallback,
  EmploymentEndCommandData: CommitmentCommandModalButtonFallback,
  EmploymentPostingCommandData: CommitmentCommandModalButtonFallback,
  EmploymentStartCommandData: CommitmentCommandModalButtonFallback,
  EmploymentUpdateCommandData: CommitmentCommandModalButtonFallback,
  HandleMoneyInBillingPaymentCommandData: CommitmentCommandModalButtonFallback,
  HandleMoneyInCommandData: CommitmentCommandModalButtonFallback,
  HandleOpenPostCommandData: CommitmentCommandModalButtonFallback,
  HandleUnitlinkBalanceCommandData: CommitmentCommandModalButtonFallback,
  HandleUnitlinkClosedPortfolioCommandData:
    CommitmentCommandModalButtonFallback,
  HandleUnitlinkMoveBalanceUpdateCommandData:
    CommitmentCommandModalButtonFallback,
  InsuredPersonStateCommandData: CommitmentCommandModalButtonFallback,
  InternalCoverTransferCommandData: CommitmentCommandModalButtonFallback,
  LifeConversionEvent: CommitmentCommandModalButtonFallback,
  LifeMigrationEvent: CommitmentCommandModalButtonFallback,
  NewBusinessEvent: CommitmentCommandModalButtonFallback,
  NewCommitmentCommandData: CreateCommitmentCommand,
  NewPolicyCommandData: CreatePolicyCommand,
  PrognosisHandleMoneyInBillingPaymentCommandData:
    CommitmentCommandModalButtonFallback,
  PrognosisHandleMoneyInCommandData: CommitmentCommandModalButtonFallback,
  ProjectionStartCommandData: CommitmentCommandModalButtonFallback,
  RelatedPersonStateCommandData: CommitmentCommandModalButtonFallback,
  RetirementCommandData: CommitmentCommandModalButtonFallback, // Exists in DK and NL
  RollbackCommandData: LifeRollbackCommand,
  SimulateToCommandData: CommitmentCommandModalButtonFallback,
  TestEvent: CommitmentCommandModalButtonFallback,
  TransformCoverCommandData: CommitmentCommandModalButtonFallback,
  UnitlinkYieldCommandData: CommitmentCommandModalButtonFallback,
  //   Seems like it can be moved from NL to general
  ValueTransferOutCommandData: CommitmentCommandModalButtonFallback,
})
